<input
  #dateTimeInput
  [formControl]="formControl"
  type="hidden"
  data-cy="FieldInput:DateTimeInput"
/>

@switch (dataType) {
  @case ('Date') {
    <blaze-inline-date
      #inlineDateComponent
      [config]="config"
      [value]="value"
      (valueChanged)="valueChange.emit($event)"
    />
  }
  @case ('Time') {
    <blaze-inline-time
      #inlineTimeComponent
      [config]="config"
      [value]="value"
      (valueChanged)="valueChange.emit($event)"
    />
  }
  @case ('DateTime') {
    <blaze-inline-date-time
      [config]="config"
      [value]="value"
      (valueChanged)="valueChange.emit($event)"
    />
  }
}

<button blazeIconButton class="clear-date" tabindex="-1" (click)="clearDateTimeValue()">
  <mat-icon svgIcon="close" />
</button>
